import React from 'react';
import CSPGrid from './csp_grid';
import ScrollTarget from '@reverbdotcom/commons/src/components/scroll_target';
import bind from '@reverbdotcom/commons/src/bind';

import { Location } from 'history';

interface IProps {
  location: Location;
  routeParams: any;
  router: any;
}

class CSPCuratedSetGrid extends React.Component<IProps, {}> {
  constructor(props) {
    super(props);
    this.changePage = this.changePage.bind(this);
  }

  componentDidUpdate() {
    this.scroll();
  }

  get params() {
    return {

      ...this.props.location.query,
      ...this.props.routeParams,
    };
  }

  scroll() {
    if (this.refs.scrollTarget) {
      (this.refs.scrollTarget as any).scrollToTop();
    }
  }

  @bind
  changePage(page) {
    this.scroll();
    this.props.router.push({
      pathname: this.props.location.pathname,
      query: Object.assign(this.props.location.query, { page }),
    });
  }

  render() {
    return (
      <div>
        <ScrollTarget onlyScrollUp ref="scrollTarget" />
        <CSPGrid
          params={this.params}
          withCuratedSets
          shouldShuffleCuratedSets={false}
          location={this.props.location}
          changePageCb={this.changePage}
        />
      </div>
    );
  }
}

export default CSPCuratedSetGrid;
